import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IdleDialog } from 'console/idle';
import { CornerNoticesContainer } from 'console/utils/corner-notice';
import { ToastContainer } from 'console/dialogs/toast';
import { LazyClimaticSettingsDialog } from 'console/climatic/lazy-settings-dialog';
import { UpgradeDialog } from 'console/device-settings/upgrade-dialog';
import { ReplaceDeviceDialog } from 'console/replaceDeviceDialog/replaceDeviceDialog';
import { BaxiSettingsMaster } from 'console/baxi/entities/master-settings/lazy-dialog';
import { TransferDeviceDialog } from 'console/transferDeviceDialog/transferDeviceDialog';
import { isMobileApp } from 'utils';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { DeleteDeviceDialog } from 'console/leftPanel/deleteDeviceDialog/delete-device-dialog';
import { ErrorDialog } from 'console/dialogs/error/dialog';
import { WidgetsHandler } from 'app/widgets';
import { SelectingDevicesDialog } from 'console/selecting-devices-dialog/dialog';
import { RadioSilenceDialog } from 'console/radio-silence-dialog/dialog';
import { RenameGroupDialog } from 'console/sortableDeviceTree/rename-group-dialog/rename-group-dialog';
import { GroupSelectorDialog } from 'console/sortableDeviceTree/add-group-selector-dialog/group-selector-dialog';
import { ProPopupRedux } from 'console/account/popup-for-pro';
import { FormSupport } from 'features/support.request/ui';
import { TopUpDialog } from 'console/billing/top-up-dialog';
import { BlockedDialog } from 'console/billing/blocked-dialog';
import { ErrorSnackRedux } from 'console/dialogs/error/snake-error/snake';
import { SimAfterDeviceAddDialog } from 'console/sim/after-device-add';
import { RoutedElements } from 'app/routes';
import { SetPinDialog } from 'console/app-settings/pin-dialogs/set';
import { PinDontMatchDialog } from 'console/app-settings/pin-dialogs/dont-match';
import { ReduxAskPinDialog } from 'console/app-settings/pin-dialogs/ask';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { MiniMaps } from 'widgets/map.corner/ui';
import { PersonalParamsUpdateDialog } from 'entities/device.private_settings/ui/dialog';
import { AccountSessionEndedDialog } from 'features/account.session-ended/ui';
const dialogs = [
    { Component: WidgetsHandler },
    { Component: SimAfterDeviceAddDialog },
    { Component: SetPinDialog, condition: () => isMobileApp() },
    { Component: PinDontMatchDialog, condition: () => isMobileApp() },
    { Component: ReduxAskPinDialog, condition: () => isMobileApp() },
    { Component: IdleDialog, condition: () => !isMobileApp() },
    { Component: ToastContainer },
    { Component: RadioSilenceDialog },
    { Component: FormSupport },
    { Component: UpgradeDialog },
    { Component: ReplaceDeviceDialog },
    { Component: BaxiSettingsMaster },
    { Component: TransferDeviceDialog },
    { Component: SelectingDevicesDialog },
    { Component: RenameGroupDialog },
    { Component: GroupSelectorDialog },
    { Component: TopUpDialog },
    { Component: PersonalParamsUpdateDialog },
    { Component: DeleteDeviceDialog },
    { Component: ErrorDialog },
    { Component: ProPopupRedux },
    { Component: ErrorSnackRedux },
    { Component: AccountSessionEndedDialog },
];
function RenderWithErrorBoundary(props) {
    const { dialogs } = props;
    return (_jsx(_Fragment, { children: dialogs.map((dialog, i) => (_jsx(ErrorBoundary, { children: (dialog.condition == null || dialog.condition()) && (_jsx(dialog.Component, {})) }, i))) }));
}
const style = { width: '100%', height: '100%' };
export const CommonUI = (props) => {
    const { children, large } = props;
    const billing_blocked = useAppSelector((state) => state.billing?.state.data.blocked && state.account.real_account == null);
    if (billing_blocked) {
        return (_jsxs(ErrorBoundary, { children: [_jsx(BlockedDialog, {}), _jsx(TopUpDialog, {})] }));
    }
    return (_jsxs("div", { style: style, children: [_jsxs(ErrorBoundary, { children: [_jsx(RenderWithErrorBoundary, { dialogs: dialogs }), _jsx(CornerNoticesContainer, { raise_above_tabs: !large, children: _jsx(ErrorBoundary, { children: _jsx(MiniMaps, {}) }) })] }), _jsx(ErrorBoundary, { children: _jsx(LazyClimaticSettingsDialog, { large: large }) }), _jsx(RoutedElements, { children: children })] }));
};
